<template>
  <v-app app id="inspire">
    <v-navigation-drawer
      app
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      width="210px"
    >
      <v-list dense>
        <v-list-item-group v-model="routingArray" color="primary">
          <v-list-item
            v-for="item in routes"
            :key="item.path"
            @click="routeTo(item.name)"
            v-if="item.hidden !== true"
            class="pr-0"
          >
            <v-layout wrap>
              <v-list-item-action>
                <v-icon
                  class=""
                  size="20"
                  :class="item.meta.selected ? `color: #82b1ff` : `color:white`"
                  >{{ item.meta.icon }}</v-icon
                >
              </v-list-item-action>
              <v-list-item-content v-if="item.hidden !== true">
                <v-list-item-title>{{ item.meta.title }}</v-list-item-title>
              </v-list-item-content>
            </v-layout>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      app
      v-if="!drawer"
      :mini-variant="!drawer"
      dark=""
      color="primary"
      mini-variant-width="60"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <v-list dense>
        <v-list-item-group v-model="routingArray">
          <v-list-item
            v-for="item in routes"
            :key="item.path"
            @click="routeTo(item.name)"
            v-if="item.hidden !== true"
          >
            <v-layout wrap v-if="item.hidden !== true">
              <v-list-item-action class="justify-center">
                <v-icon
                  size="20"
                  :class="item.meta.selected ? `color: #82b1ff` : `color:white`"
                  >{{ item.meta.icon }}</v-icon
                >
              </v-list-item-action>
            </v-layout>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar fixed clipped-left app>
      <v-app-bar-nav-icon @click.stop="$store.dispatch('SetnavigationDrawer', !$store.getters.navigationDrawerShow);drawer=!drawer"></v-app-bar-nav-icon>
      <v-flex class="text-left" align="start" justify="left">
        <v-breadcrumbs :items="crumbs" divider=">" class="px-0">
        </v-breadcrumbs>
      </v-flex>

      <v-spacer></v-spacer>

      <v-toolbar-title>
        <v-menu
          v-model="menu"
          offset-y
          :close-on-content-click="false"
          :nudge-width="260"
        >
          <template v-slot:activator="{ on }">
            <a v-on="on" class="white--text">
              <v-avatar size="40">
                <v-img v-if="profilePhoto !== ''" :src="profilePhoto" @error="profilePhoto = ''" />
                <img
                  v-else
                  src="@/assets/images/avatar.jpg"
                />
              </v-avatar>
            </a>
          </template>
          <v-card>
            <div class="divDisplay">
              <div class="titleText">
                <p class="">
                  {{ userDetail.firstName }} {{ userDetail.lastName }}
                </p>
              </div>
              <v-avatar size="100" color="red">
                <v-img v-if="profilePhoto !== ''" :src="profilePhoto" @error="profilePhoto = ''" />
                <img
                  v-else
                  src="@/assets/images/avatar.jpg"
                />
              </v-avatar>
            </div>
            <v-divider class="mt-5"></v-divider>
            <v-list dense class="text-center">
              <v-list-item-group color="primary">
                <v-list-item @click="routeToEmployeeDetails">
                  <v-list-item-content>
                    <p>View Profile</p>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <!-- <v-list-item @click="routeToTimesheetDetails">
                  <v-list-item-content>
                    <p>View My Timesheet</p>
                  </v-list-item-content>
                </v-list-item> -->
                <v-divider></v-divider>
                <v-list-item @click="LogOut()">
                  <v-list-item-content>
                    <p>Log Out</p>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar-title>
      <!-- <v-icon class="ml-3 primary--text""
        >notifications</v-icon
      > -->
      <!-- <div class="text-center c-pointer">
        <v-badge color="error" :overlap="true" class="align-self-center">
          <template v-slot:badge>
            <span>30</span>
          </template>
          <v-icon
            size="28"
            class="pl-2"
            color="primary"
            @click="notificationDrawer()"
          >
            notifications
          </v-icon>
        </v-badge>
      </div> -->
      <NotificationDrawer v-if="notification" />
    </v-app-bar>
    <v-content class="mx-2 my-2">
      <section class="app-main" style="min-height:100%">
        <transition name="fade-transform">
          <router-view />
        </transition>
      </section>
      <loader
        v-if="$store.getters.showLoader"
        v-bind:data="$store.getters.loaderMessage"
      ></loader>
      <snakBar
        v-if="$store.getters.showAlert"
        v-bind:status="$store.getters.showAlert"
        v-bind:message="$store.getters.alertMessage"
        v-bind:color="$store.getters.alertColor"
      >
      </snakBar>
      <fileUploadLoader />
    </v-content>
  </v-app>
</template>
<script>
import snakBar from '@/View/components/SnakBar.vue'
import Loader from '@/View/components/Loader.vue'
import NotificationDrawer from '@/View/HRM/layout/NotificationDrawer.vue'
import {HRM} from '../router/index.js'
import fileUploadLoader from '@/View/components/fileUploadLoader'

export default {
  components: {
    Loader,
    snakBar,
    NotificationDrawer,
    fileUploadLoader
  },
  props: {
    source: String
  },
  data () {
    return {
      userDetail: {},
      bar: true,
      routes: [],
      isActive: true,
      menu: false,
      drawer: this.$store.getters.navigationDrawerShow,
      items: [],
      routingArray: false,
      toolbarTitle: true,
      toolbarTitleVal: 'Management',
      employeeName: '',
      employeeId: 0,
      profilePhoto: '',
      notification: false
    }
  },
  computed: {
    crumbs: function () {
      let pathArray = this.$route.path.split('/')
      let parentRouter = [
        {
          text: 'App',
          href: '#/dashboard',
          disabled: false
        },
        {
          text: 'HRM',
          href: '#/HRM/Dashboard',
          disabled: this.$route.path === '/HRM/Dashboard'
        }
      ]
      for (let hrm of HRM.children) {
        let obj = {
          text: '',
          href: '',
          disabled: false
        }
        if (hrm.meta.breadCrumb.toLowerCase() === pathArray[2].toLowerCase()) {
          obj.text = hrm.meta.title
          obj.href = '#' + hrm.path
          obj.disabled = this.$route.name === hrm.redirect.name
          parentRouter.push(obj)
        }
      }
      parentRouter.push({
        text: this.$route.meta.title,
        disabled: true,
        href: ''
      })
      return parentRouter
    }
  },
  mounted () {
    this.profilePhoto = localStorage.getItem('profileImageUrl')

    let userData = localStorage.getItem('_Data11')
    this.userDetail = JSON.parse(userData)

    this.getNavigationIconFromRouterWithPermissions()

    this.$root.$on('Closedrawer', (data) => {
      this.notification = false
    })
  },
  beforeDestroy () {
    this.$root.$off('Closedrawer')
  },
  watch: {
    $route: function () {
      this.toolbarTitleVal = this.$router.apps[0]._route.meta.title
    }
  },
  methods: {
    notificationDrawer () {
      this.notification = true
    },
    getNavigationIconFromRouterWithPermissions () {
      let permissionArray = this.$store.getters.permission
      HRM.children.forEach(b => {
        if (!b.hidden && b.meta !== undefined) {
          if (this.userDetail.isAdmin) {
            this.routes.push(b)
          } else {
            if (b.meta.title === 'settings' || b.name === 'HRMDashboard') {
              if (b.meta.title === 'settings') {
                for (let per = 0; per < permissionArray.length; per++) {
                  if (permissionArray[per].name.toLowerCase() === 'settings') {
                    if (permissionArray[per].subMenuPermissions !== null) {
                      let isViewAllAreFalse = false
                      for (let sub = 0; sub < permissionArray[per].subMenuPermissions.length; sub++) {
                        if (permissionArray[per].subMenuPermissions[sub].isViewAll === true) {
                          isViewAllAreFalse = true
                          break
                        }
                      }
                      if (isViewAllAreFalse) {
                        this.routes.push(b)
                        break
                      }
                    }
                  }
                }
              } else {
                this.routes.push(b)
              }
            } else {
              if (b.meta !== undefined) {
                let filterData = permissionArray.filter(val => {
                  return val.slug === b.meta.title.toLowerCase()
                })
                if (filterData[0] !== undefined) {
                  if (filterData[0].isViewAll || filterData[0].isViewRelated) {
                    this.routes.push(b)
                  }
                }
              }
            }
          }
        }
      })
    },
    LogOut () {
      localStorage.removeItem('authToken')
      localStorage.removeItem('_Data11')
      this.$store.dispatch('GetEmployeePermission', true)
      this.$router.push({name: 'login'})
    },
    routeTo (path) {
      for (let index = 0; index < this.routes.length; index++) {
        if (path === this.routes[index].name) {
          this.routes[index].meta.selected = true
        } else {
          this.routes[index].meta.selected = false
        }
      }
      this.$router.push({name: path})
    },
    routeToEmployeeDetails () {
      let id = this.userDetail.EmployeeId
      this.$router.push({name: 'EmployeeDetail', params: {employeeId: id}})
    },
    routeToTimesheetDetails () {
      this.$router.push({name: 'MyTimeSheetDetails', params: {timesheetId: 0, redirectFromMenu: true}})
    },
    resizeGrid () {
      if (window.innerWidth < 800) {
        this.toolbarTitle = false
      } else {
        this.toolbarTitle = true
      }
    }
  }
}
</script>
<style scoped>

.divDisplay {
  display: grid;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
}
.titleText {
  font-size: 22px;
  font-weight: 600 !important;
  padding: 2px;
}
.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 0.9125rem !important;
  font-weight: 500 !important;
  line-height: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/View/HRM/layout/layout.vue